import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isNotDarkTheme } from '../../theme/style-mixins/isDarkTheme/isNotDarkTheme-BpLwrzY3.js';
import { g as globalStyles, s as smallStyles, n as normalStyles, d as defaultAiStyles, l as loadingStyles } from '../Button.styles-Ck-xVxAl.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../../Icon/Icon-AcXbY_t4.js';
import { s as spinner, f as aiSearch, g as aiAgent } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1cyknbu-0"
})([""]);
const StyledButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1cyknbu-1"
})(["", ";", ";", " ", " &&:focus-visible{", "}", " margin:0;"], globalStyles, ({
  $size
}) => $size === 'small' ? smallStyles : normalStyles, defaultAiStyles, ({
  $loading
}) => $loading && css(["{", " border-color:transparent;}"], loadingStyles), focusOutline, isNotDarkTheme(css(["&&:hover:not(:disabled) ", "{color:", ";}"], StyledIcon, ({
  theme
}) => theme.support.iconColor.ai)));
const AIPromptButton = ({
  type = 'button',
  variant = 'agent',
  buttonRef,
  children,
  disabled,
  loading,
  loadingLabel,
  onClick,
  size = 'base',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('ai-prompt-button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
  disabled: disabled,
  type: type,
  ref: buttonRef,
  $size: size,
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, (loading || disabled) && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: spinner,
  size: size
}), loadingLabel || children), !loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledIcon, {
  type: variant === 'search' ? aiSearch : aiAgent,
  size: size
}), children)));

export { AIPromptButton as A };
//# sourceMappingURL=AIPromptButton-DZaMejNW.js.map
